import {Component, OnInit} from '@angular/core';
import {TitleWrapperService} from "../../../service/title-wrapper.service";
import {TranslationService} from "../../../service/translation.service";

@Component({
  selector: 'app-forgott-password',
  templateUrl: './forgott-password.component.html',
  styleUrls: ['./forgott-password.component.scss']
})
export class ForgottPasswordComponent implements OnInit {

  constructor(
    private translationService: TranslationService,
    private titleService: TitleWrapperService,
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
  }

  private updateTitle() {
    this.titleService.setPageName(this.translationService.trans("forgot_password.page_title", "Forgot password"));
  }

}
